enum SORT_DIR {
    ASC = 'asc',
    DESC = 'desc'
}

export {
    SORT_DIR,
}